/* eslint-disable  @typescript-eslint/no-explicit-any */

import React, { Component } from 'react';
import { Text as RNText, StyleSheet, TextInputProps } from 'react-native';
import { FontService } from '../../services/font';
import { ThemeContext } from '../ThemeProvider';

const getStyles = (theme: Theme): Record<string, Record<string, string>> =>
  StyleSheet.create({
    text: {
      textAlign: 'left',
      backgroundColor: theme.colors.transparent,
      color: theme.colors.neutral,
    },
  });

interface TextProps extends TextInputProps {
  children: any;
  style?: any;
}

export class Text extends Component<TextProps, {}> {
  static displayName = 'Text';
  static contextType = ThemeContext;

  theme: Theme = this.context as React.ContextType<typeof ThemeContext>;
  _ref;
  styles = getStyles(this.theme);

  setNativeProps(nativeProps): void {
    this._ref.setNativeProps(nativeProps);
  }

  setRef(component): void {
    this._ref = component;
  }

  render(): React.JSX.Element{
    const customStyleObject = StyleSheet.flatten(this.props.style) || {};

    return (
      <RNText
        {...this.props}
        ref={(component): void => {
          this.setRef(component);
        }}
        style={[
          this.styles.text,
          this.props.style,
          FontService.getStyle(
            customStyleObject.fontFamily || this.theme.font.family,
            customStyleObject.fontWeight,
            customStyleObject.fontStyle,
          ),
        ]}
        allowFontScaling={false}>
        {this.props.children}
      </RNText>
    );
  }
}
